// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"ec95e2e2","239":"e23f8df6","455":"ccaaa782","977":"2ebd44d1"}[chunkId] + ".chunk.js";
};